import { Container, Typography, Button } from '@mui/material';

const NotFoundPage = () => {

    const redirectToHome = () => {
        window.location.href = '/';
      };

  return (
    <Container maxWidth="sm" style={{ marginTop: '4rem', textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        Page Not Found
      </Typography>
      <Typography variant="body1" paragraph>
        The page you are looking for does not exist or might have been removed.
      </Typography>
      <Button onClick={redirectToHome} variant="contained" color="primary">
        Go to Home
      </Button>
    </Container>
  );
};

export default NotFoundPage;
